export const reprintPin = {
    deliveryManagement: {
        enabled: true,
    },
};
